/**
 * Keyboard shortcuts with the platform's command key: ⌘ on Apple devices, Ctrl
 * elsewhere (either is accepted, as in the rest of the admin, so an external
 * keyboard's habit still works).
 */
export const isApplePlatform = () => /Mac|iPhone|iPad|iPod/.test(navigator.platform || '');

// The modifier as the keyboard prints it; translate "Ctrl" where the label is shown ("Strg").
export const commandKeyLabel = () => (isApplePlatform() ? '⌘' : 'Ctrl');

export const isCommandShortcut = (event, key) =>
    (event.metaKey || event.ctrlKey) && !event.altKey && String(event.key).toLowerCase() === key;
